import * as yup from "yup";

export const SupplierValidationSchema = yup.object().shape({
    name: yup.string().max(100, "Name not more than 100 Characters.").required("Name is Required"),
    contact_name_one: yup.string().max(100, "Contact name one not more than 100 Characters.").required("Contact name one is Required"),
    contact_number_one: yup.string().max(20, "Contact number one not more than 20 Characters.").required("Contact number one is Required"),
    contact_name_two: yup.string().max(100, "Contact name two not more than 100 Characters."),
    contact_number_two: yup.string().max(20, "Contact number two not more than 20 Characters."),
    contact_email: yup.string().email('Invalid email address. Like: alim@dekkoisho.com').max(50, "Email not more than 50 Characters."),
    address_one: yup.string().max(200, "Address one not more than 200 Characters.").required("Address one is Required"),
    address_two: yup.string().max(200, "Address two not more than 200 Characters."),
    website: yup.string().max(50, "Website not more than 50 Characters."),
    remark: yup.string().max(250, "Remark not more than 250 Characters."),
});
